import type { RouteLocationRaw } from "vue-router";
import { EntityFromGenericTableColumnDefinition, GenericTableColumnDefinitions } from "./type.genericTableColumnDefinition";
import { GenericTableSchema } from "./type.genericTableSchema";

export enum GenericTableRowConfigType {
  ACTION = "action",
  LINK = "link",
  NONE = "none",
}

export type GenericTableRowConfig<T extends GenericTableSchema, S extends GenericTableColumnDefinitions<T>> =
  | {
      type: GenericTableRowConfigType.ACTION;
      onClick: (entity: EntityFromGenericTableColumnDefinition<T, S>) => void;
      class?: (entity: EntityFromGenericTableColumnDefinition<T, S>) => string;
    }
  | {
      type: GenericTableRowConfigType.LINK;
      to: (entity: EntityFromGenericTableColumnDefinition<T, S>) => RouteLocationRaw | string;
      disabled: boolean;
      class?: (entity: EntityFromGenericTableColumnDefinition<T, S>) => string;
    }
  | {
      type: GenericTableRowConfigType.NONE;
      class?: (entity: EntityFromGenericTableColumnDefinition<T, S>) => string;
    };
